import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceContentsSettingForm',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String,
    serviceContentsId: String
  },
  data () {
    return {
      loading: true
    }
  },
  // beforeMount () {
  //   if (this.getPermission('User')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.resetForm()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceContentsSetting.categoryName
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isRegister: 'serviceContentsSettingForm/isRegister',
      isModify: 'serviceContentsSettingForm/isModify'
    })
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      loadModel: 'serviceContentsSettingForm/loadModel',
      resetForm: 'serviceContentsSettingForm/reset'
    }),

    init () {
      this.loading = true

      //
      let serviceTypeParams = {}
      let serviceContentsSettingParams = {
        serviceUuid: this.serviceId,
        serviceContentsUuid: this.serviceContentsId
      }
      let deviceParams = { filters: {} }

      // データ読出し
      this.loadModel({
        serviceId: this.serviceId,
        targetId: this.serviceContentsId,
        serviceTypeParams: serviceTypeParams,
        serviceContentsSettingParams: serviceContentsSettingParams,
        deviceParams: deviceParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    }
  }
}
